export const STATUS_ATUAL = 'atual';
export const STATUS_COMPLETO = 'completo';
export const STATUS_INCOMPLETO = 'incompleto';